import { Grid } from 'react-bootstrap';
import * as React from 'react';

export const MTAPremiumMismatch = () => {
  return (
    <div className="admiral-card">
      <div className="header">
        Sorry:
      </div>
      <div className="body">
        <Grid fluid={true}>
          <div>
            <p style={{ marginTop: '30px' }}>Unfortunately, we have been unable to make the change you have
              requested.</p>
            <p>Please call us on 0333 234 9913, lines are open 9am until 6pm from Monday to Friday (closed on
              weekends) to discuss this further.</p>
            <p>It is important that your details are kept up to date, as incorrect information could invalidate
              your cover or affect any future claims.</p>
          </div>
        </Grid>
      </div>
    </div>
  )
}
